module.exports = __webpack_public_path__ + "img/2.9f697eb6.svg";